import { Routes, Route } from 'react-router-dom';
import { RestaurantProvider } from '../components/Products/Reservo/contexts/RestaurantContext.tsx';
import { ReservationProvider } from '../components/Products/Reservo/contexts/ReservationContext.tsx';

import PrivateRoute from '../components/common/PrivateRoute.js';
import AdminLayout from '../components/Products/Reservo/layouts/AdminLayout.tsx';
import AdminDashboard from '../components/Products/Reservo/pages/admin/AdminDashboard.tsx';
import FloorPlanEditor from '../components/Products/Reservo/pages/admin/FloorPlanEditor.tsx';
import ReservationCalendar from '../components/Products/Reservo/pages/admin/ReservationCalendar.tsx';
import TodayReservations from '../components/Products/Reservo/pages/admin/TodayReservations.tsx';
import ReportsPage from '../components/Products/Reservo/pages/admin/ReportsPage.tsx';
import SettingsPage from '../components/Products/Reservo/pages/admin/SettingsPage.tsx';
import TutorialPage from '../components/Products/Reservo/pages/admin/TutorialPage.tsx';
import '../components/Products/Reservo/styles/global.css';

const ReservoRoutes = () => {
  return (
    <RestaurantProvider>
      <ReservationProvider>
        <Routes>

          {/* Rotas privadas: /reservo/* */}
          <Route
            path="/"
            element={
              <PrivateRoute product="reservo">
                <AdminLayout />
              </PrivateRoute>
            }
          >
            <Route index element={<AdminDashboard />} />
              <Route path="plantas" element={<FloorPlanEditor />} />
              <Route path="calendario" element={<ReservationCalendar />} />
              <Route path="hoje" element={<TodayReservations />} />
              <Route path="relatorios" element={<ReportsPage />} />
              <Route path="configuracoes" element={<SettingsPage />} />
              <Route path="tutorial" element={<TutorialPage />} />
          </Route>

        </Routes>
      </ReservationProvider>
    </RestaurantProvider>
  );
};

export default ReservoRoutes;